

export const environment = {
  production: true,
  modules: [],
  graphqlUri: 'https://admindev.mynatomame.cz/graphql',
  port: '5676', 
  baseUrl: 'https://admindev.mynatomame.cz'

};

/* 

LIVE

  graphqlUri: 'https://admin.mynatomame.cz/graphql',
  port: '5676', 
  baseUrl: 'https://admin.mynatomame.cz'


DEVELOP

  graphqlUri: 'https://admindev.mynatomame.cz/graphql',
  port: '38254',
  baseUrl: 'https://admindev.mynatomame.cz'

DEVELOP live backend

  graphqlUri: 'https://admin.mynatomame.cz/graphql',
  port: '38254',
  baseUrl: 'https://admin.mynatomame.cz'

FRONTDEV

  graphqlUri: 'https://admin.mynatomame.cz/graphql',
  port: '14197', 
  baseUrl: 'https://admin.mynatomame.cz' 

 */


